// extracted by mini-css-extract-plugin
module.exports = {"like":"like_like__w_gEn","active":"like_active__nkaN6"};